<template>
  <div>
    <!-- <el-form> -->
 <el-form-item label="校验码">
      <el-input placeholder="请输入内容" v-model="imgCode">
        <template slot="append">
          <img
            :src="imageBase64"
            alt=""
            style="width: 100px;height: 20px;"
            @click="getImageData"
          />
        </template>
      </el-input>
    </el-form-item>
    <el-form-item label="验证码">
      <el-input
        placeholder="请输入"
        :value="verification_code"
        @input="inputCode"
      >
        <template slot="append">
          <el-link :disabled="btn_status" @click="getCode" type="primary">
            {{ code_text }}
          </el-link>
        </template>
      </el-input>
    </el-form-item>
    <!-- </el-form> -->
  </div>
</template>

<script>
import verificationCode from "@/utils/verificationCode";

export default {
  model: {
    prop: 'verification_code', // 可任意定义的变量，用来接收父组件 v-model 中传递过来的值
    event: 'change'
  },
  props:{
    typeCode:{
      type:Number,
      default:0
    },
    form:{
      type:Object,
    },
    verification_code: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      imageBase64: "",
      imgCode: "",
      uuid: "",
      // verification_code:"",
      code_text: "获取验证码",
      btn_status: false,
      timer: null,
      count:0
    };
  },
  created() {
    this.timer = null
    this.count = 0
    this.getImageData()
  },
  methods: {
    async getImageData() {
      const data = await verificationCode.getImage();
      if (data) {
        console.log("验证图片", data);
        this.imageBase64 = data.img;
        this.uuid = data.uuid;
        this.imgCode = "";
      }
    },
    inputCode(value){
      console.log(value)
      this.$emit('change', value)
      // this.$emit("input", value);
      // this.$emit("inputValue",value)
    },
     async getCode() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        if(this.typeCode == 0){
          // 向管理员发送验证码
          verificationCode.SendMyCode({uuid:this.uuid,code:this.imgCode,...this.form})
        }else{
          // 给用户发验证码
          verificationCode.SendUserCode({uuid:this.uuid,code:this.imgCode,...this.form})
        }
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
            this.code_text = this.count + "s";
            this.btn_status = true;
          } else {
            this.btn_status = false;
            this.timer = null;
            this.code_text = "获取验证码";
          }
        }, 1000);
      }
    },
  },
};
</script>
